import React from 'react';
import { Edit } from 'react-admin';
import LocationForm from './form';

const LocationEdit = (props) => {
  const { resource } = props;
  return (
    <Edit
      mutationMode="optimistic"
      title={`resources.${resource}.titles.edit`}
      {...props}
    >
      <LocationForm />
    </Edit>
  );
};

export default LocationEdit;
